export default __webpack_public_path__ + "open_quote.e897aa93.svg";